export default {
  width: 31,
  height: 24,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.37 6.14H5a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1V7.14a1 1 0 0 0-1-1h-5.37L17.39 3H13.6l-3.24 3.14zM12.8 1L9.56 4.14H5a3 3 0 0 0-3 3V20a3 3 0 0 0 3 3h21a3 3 0 0 0 3-3V7.14a3 3 0 0 0-3-3h-4.56l-2.95-2.86a1 1 0 0 0-.7-.28H12.8z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 7a.9.9 0 0 0 0 1.8 3.74 3.74 0 0 1 3.74 3.78v1.26l-.77-.77a.9.9 0 1 0-1.28 1.27l2.32 2.32a.9.9 0 0 0 1.28 0l2.32-2.32a.9.9 0 1 0-1.28-1.27l-.78.78v-1.3A5.54 5.54 0 0 0 15.5 7zm-1.72 5.86a.9.9 0 0 1-1.27 0l-.78-.78v1.3a3.74 3.74 0 0 0 3.74 3.74.9.9 0 1 1 0 1.8 5.54 5.54 0 0 1-5.54-5.54v-1.3l-.79.78a.9.9 0 0 1-1.27-1.28l2.32-2.32a.9.9 0 0 1 1.27 0l2.32 2.32a.9.9 0 0 1 0 1.28z"/>
  `
}
